module.exports = __webpack_public_path__ + "img/4.9acead1c.png";